/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ActionsGridColumns {
    Association = 'association',
    Panel = 'panel',
    CreatedBy = 'created_by',
    CreatedDate = 'created_date',
    UpdatedBy = 'updated_by',
    UpdatedDate = 'updated_date',
    ResponsibleFunction = 'responsible_function',
    Id = 'id',
    RecordId = 'record_id',
    ObservationId = 'observation_record_id',
    Owner = 'owner',
    Resolution = 'resolution',
    Description = 'description',
    Comments = 'comments',
    Status = 'status',
    RequestedDate = 'requested_date',
    DueDate = 'due_date',
    CompletedDate = 'completed_date',
    CompletedDatePopulatedOn = 'completed_date_populated_on',
    Site = 'site',
}

export class SmActionsGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    disableAdvancedFilter(): boolean {
        return false;
    }

    disableLock(): boolean {
        return false;
    }

    getActiveField(columnType: ColumnDefinition): string | undefined {
        switch (columnType.dataField) {
            case ActionsGridColumns.Association:
            case ActionsGridColumns.Panel:
            case ActionsGridColumns.ResponsibleFunction:
            case ActionsGridColumns.Owner: {
                return `${columnType.dataField}_active`;
            }
            default:
                return undefined;
        }
    }

    actionsColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ActionsGridColumns.Status, 110],
        [ActionsGridColumns.Site, 115],
        [ActionsGridColumns.Association, 180],
        [ActionsGridColumns.Panel, 180],
        [ActionsGridColumns.Description, 400],
        [ActionsGridColumns.Comments, 200],
        [ActionsGridColumns.Owner, 200],
        [ActionsGridColumns.Resolution, 200],
        [ActionsGridColumns.ResponsibleFunction, 190],
        [ActionsGridColumns.RequestedDate, 145],
        [ActionsGridColumns.DueDate, 145],
        [ActionsGridColumns.CompletedDate, 145],
        [ActionsGridColumns.CompletedDatePopulatedOn, 185],
        [ActionsGridColumns.CreatedDate, 145],
        [ActionsGridColumns.UpdatedDate, 145],
        [ActionsGridColumns.CreatedBy, 145],
        [ActionsGridColumns.UpdatedBy, 145],
        [ActionsGridColumns.RecordId, 100],
        [ActionsGridColumns.ObservationId, 100],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.actionsColumnsWidth.get(columnType.dataField);
    }

    getCustomCell() {
        return undefined;
    }

    getDisplayFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ActionsGridColumns.CreatedBy:
            case ActionsGridColumns.CreatedDate:
            case ActionsGridColumns.UpdatedBy:
            case ActionsGridColumns.UpdatedDate:
            case ActionsGridColumns.Id:
            case ActionsGridColumns.ObservationId:
            case ActionsGridColumns.RecordId:
                return false;
            default:
                return true;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ActionsGridColumns.Description:
            case ActionsGridColumns.Resolution:
            case ActionsGridColumns.Owner:
            case ActionsGridColumns.Comments:
            case ActionsGridColumns.Association:
            case ActionsGridColumns.Panel:
            case ActionsGridColumns.ResponsibleFunction:
                return true;
            default:
                return false;
        }
    }

    isRagColumn(): boolean {
        return false;
    }

    multiValueFilter(): boolean {
        return false;
    }
}
